import "./fcopel/style.css";
import { Sectionpd} from "../componentes/padroes";
import { Sectioninterna, Btnnav, Desctablet, Paragrafoint, Navcommand, Tags, Flexmidbanner, InternoBanner } from "./padroespages";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

function EnergisaPrev() {
  return (
    <main>
        <Helmet>
            <title>Energisaprev - Gabriel Barbosa</title>
            <meta name="description" content="Desdobramento do Site principal da EnergisaPrev, dispondo das informações do relatório anual de investimentos do fundo previdenciário privado destinado aos associados do grupo Energisa, holding brasileira de distribuição de energia." />
        </Helmet>
        <InternoBanner style={{ backgroundImage: 'url(/img/clientes/capa_energisaprev.jpg'}}>
            <div className="container z-2">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="descbannerint">
                            <h1>EnergisaPrev</h1>
                            <Flexmidbanner>
                                <a href="https://energisaprev.com.br/relatorioanual2023" target="_blank" rel="noreferrer">energisaprev.com.br/relatorioanual2023</a>
                                <span>VIA CRT COMUNICAÇÃO</span>
                            </Flexmidbanner>
                            <Tags>//FRONT-END + WORDPRESS</Tags>
                            <Paragrafoint>Desdobramento do Site principal da EnergisaPrev, dispondo das informações do relatório anual de investimentos do fundo previdenciário privado destinado aos associados do grupo Energisa, holding brasileira de distribuição de energia.</Paragrafoint>  
                        </div>
                    </div>
                </div>
            </div>
        </InternoBanner>
        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/raienergisa.jpg" alt="Home do RAI EnergisaPrev 2023" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Desctablet>Fui responsável pela criação do site com foco no uso interno dos contribuintes e associados da Fundação COPEL, funcionando como uma "área privada" exclusiva. O projeto foi desenvolvido utilizando HTML, CSS, JavaScript e PHP, e também integrei o WordPress como CMS para facilitar a administração de conteúdo e permitir que os usuários realizem atualizações de forma simples.</Desctablet>
                    </div>
                </div>
            </div>
        </Sectioninterna>

        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/internarai.png" alt="Página Interna - RAI 2023" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Desctablet>O site oferece uma série de funcionalidades essenciais, como um sistema de chat ao vivo para facilitar a comunicação em tempo real, além de permitir a consulta e download de documentos, o que otimiza a gestão interna. O projeto foi desenvolvido para incorporar recursos adicionais que melhoram a interação entre os contribuintes e a empresa. Hoje, o site continua sendo mantido e atualizado com novas funcionalidades, com o objetivo de proporcionar uma experiência mais fluida e moderna para os usuários.</Desctablet>
                    </div>
                </div>
            </div>
        </Sectioninterna>
        <Sectionpd>
            <div className="container">
                <div className="row">
                    <div className="col-6 order-1 order-lg-0 col-lg-5 align-content-lg-center col-5 justify-content-lg-end text-lg-end">
                        <Link to="/fcopel" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//ANTERIOR</span>
                                <h3>Fundação COPEL</h3>
                                <span>//FRONT-END + BANCO DE DADOS</span>
                            </Btnnav>
                        </Link>
                    </div>
                    <div className="col-12 order-0 col-lg-2 order-lg-1">
                        <Navcommand>
                            <Link to="/fcopel" style={{ textDecoration: 'none' }}></Link>
                            <span></span>
                            <Link to="/prestador" style={{ textDecoration: 'none' }}></Link>
                        </Navcommand>
                    </div>
                    <div className="col-6 order-2 col-lg-5 order-lg-2 align-content-lg-center col-5 justify-content-lg-end">
                        <Link to="/prestador" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//PRÓXIMO</span>
                                <h3>COPEL Prestador</h3>
                                <span>//FRONT-END + INTEGRAÇÃO + WORDPRESS</span>
                            </Btnnav>
                        </Link>
                    </div>
                </div>
            </div>
        </Sectionpd>
    </main>
  );
}

export default EnergisaPrev;